module.exports = __webpack_public_path__ + "media/images/views/home/step/step-2-fa63f3cc515cc69e41fb450f6cb99e87.png";